                                                 
export const AUTH_GET_TOKEN_METHOD = 'auth:getToken' as const;
export const AUTH_REFRESH_TOKEN_METHOD = 'auth:refreshToken' as const;

                                  
export const LOGIN_AUTH_GET_TOKEN_METHOD = 'login:auth:getToken' as const;
export const LOGIN_AUTH_REFRESH_TOKEN_METHOD =
  'login:auth:refreshToken' as const;

export type AuthErrorCode = 'no_token' | 'dismissed' | 'refresh_failed';

export interface AuthTokenResult {
  accessToken: string;
}

export interface LoginAuthRequestPayload {
                                                                                     
  silent?: boolean;
}

                                                                                                  
export const AUTH_STORAGE_KEYS = {
  refreshToken: 'sync-video:refresh-token',
} as const;

export function isAuthTokenResult(value: unknown): value is AuthTokenResult {
  if (!value || typeof value !== 'object') {
    return false;
  }
  return typeof (value as AuthTokenResult).accessToken === 'string';
}

export function parseAuthTokenResult(value: unknown): AuthTokenResult {
  if (!isAuthTokenResult(value)) {
    throw new Error('Invalid auth token result');
  }
  return value;
}

export function authErrorMessage(code: AuthErrorCode): string {
  return `sync-video/auth/${code}`;
}

export function parseAuthErrorMessage(message: string): AuthErrorCode | null {
  const prefix = 'sync-video/auth/';
  if (!message.startsWith(prefix)) {
    return null;
  }
  const code = message.slice(prefix.length) as AuthErrorCode;
  if (
    code === 'no_token' ||
    code === 'dismissed' ||
    code === 'refresh_failed'
  ) {
    return code;
  }
  return null;
}
